import { useEffect } from 'react';

export const usePayloadForNonKimbleCompany = (setFinalizeCompany, setClaims, id_in_provider_system_and_companies_house_number, claimTemplateService, setClaimTemplates, setCompany) => {

  useEffect(() => {
    // for DE we want this to already be true since we do not require claim select page
    if (process.env.PUBLIC_URL !== '/de') return;

    const query = new URLSearchParams(location.search);
    const finalizeCompanyQuery = query.get('finalizecompany') || 'false';
    const companyNameQuery = query.get('company_name');

    if (finalizeCompanyQuery === 'true') {
      setFinalizeCompany(true)
    }

    const customClaim = {
      from_date: '01/01/2020',
      to_date: '31/12/2020',
      include: true,
      name: 'companyNameQuery',
    }

    const fetchClaimTemplates = async () => {
      const claimTemplates = await claimTemplateService.get();
      setClaimTemplates(claimTemplates);
    }

    fetchClaimTemplates();
    setClaims([customClaim]);

    const [kimbleId, companiesHouseNumber] = id_in_provider_system_and_companies_house_number.split('--')

    setCompany({
      name: companyNameQuery,
      has_made_claims_before: false,
      number: companiesHouseNumber,
      id_in_provider_system: kimbleId,
      accounts_period_changed: false,
      company_users: [],
      claims: [customClaim],
      country: 'germany',
      claim_group:
      {
        name: '',
        consultants_attributes: [],
        has_overdue_taxes: false,
        has_staff_involved_not_on_payroll: false,
        accounts_provided: false,
        tax_computations_provided: false,
        development_costs_capitalised: false,
        contracted_by_third_party: false,
        received_grants_or_subsidies: false,
        reimburses_staff_expenses: false,
        purchased_company_cars: false,
        has_patents: false
      },
    });


  }, [id_in_provider_system_and_companies_house_number, setClaims, setCompany, setFinalizeCompany, claimTemplateService, setClaimTemplates]);

}
